module.exports = __webpack_public_path__ + "static/media/mem1.403f1fce.jpg";